import { defineStore } from 'pinia';

export const useStore = defineStore('main', {
  state(){ 
    return {
      row: {}
    }
  },
  getters:{},
  actions:{}
})


// WEBPACK FOOTER //
// ./src/pinia/stores.js